import { render } from "./addpayment_gift.vue?vue&type=template&id=35cf22a5"
import script from "./addpayment_gift.vue?vue&type=script&lang=js"
export * from "./addpayment_gift.vue?vue&type=script&lang=js"

import "./addpayment_gift.vue?vue&type=style&index=0&id=35cf22a5&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__